// src/pages/LandingPage.js
import React from 'react';
import { Box, Container } from '@mui/material';
import Header from '../components/Header';
import About from '../components/About';
import Skills from '../components/Skills';
import Projects from '../components/Experience';
import Footer from '../components/Footer';
import PersonalInfo from '../components/PersonalInfo';
import Languages from '../components/Languages';
import Education from '../components/Education';
import { TextProvider } from '../context/TextContext';  // Import the TextProvider
import Certifications from '../components/Certifications';

const LandingPage = () => {
  return (
    <TextProvider>  {/* Wrap the page with TextProvider */}
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#F3F2F1' }}>
        <Header />
        <Container sx={{ flex: 1, py: 2 }}>
          <PersonalInfo />
          <About />
          <Skills />
          <Projects />
          <Languages />
          <Education />
          <Certifications />
        </Container>
        <Footer />
      </Box>
    </TextProvider>
  );
};

export default LandingPage;
